import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import React from "react";

const MobileTabs = ({ tabs, value, modifier }) => {
  return (
    <IonSegment
      value={value}
      scrollable
      mode="ios"
      className="mb-3"
    >
      {tabs?.map((tab) => (
        <IonSegmentButton
          key={tab.value}
          onClick={() => modifier(tab.value)}
          value={tab.value}
        >
          <IonLabel className="small text-nowrap">{tab.label}</IonLabel>
        </IonSegmentButton>
      ))}
    </IonSegment>
  );
};

export default MobileTabs;
